import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataFileConfigurationComponent } from './landing/data-file-configuration/data-file-configuration.component';
import { Routes, RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { SnAuthGuard } from '@insight/serenity-auth';
import { PersonaGuard } from '../auth/authguards/persona-guard';


const routes: Routes = [
  { path: 'file-config', component: DataFileConfigurationComponent, canActivate: [SnAuthGuard, PersonaGuard]}
];

@NgModule({
  declarations: [DataFileConfigurationComponent],
  imports:
  [
    CommonModule,
    RouterModule.forChild(routes),
    NgxDatatableModule,
    NgbModule,
    FormsModule
  ]
})
export class DataFileConfigutationModule { }
